import { lazy } from "react";
// Module H — Member Outreach Campaign Engine (Outreach Console)
// Cola de miembros sin visita reciente, contactabilidad y log de outreach.

const MemberOutreachPage = lazy(() => import("./pages/MemberOutreachPage"));
// Export routes for AppRouter
export const memberOutreachRoutes = [
  {
    path: "/member-outreach",
    element: <MemberOutreachPage />,
  },
];

// Export components for external use
